export default function actionButtons(buttons=[]) {

    function render(params) {
        const $containerButtons = document.createElement('div');

        $containerButtons.classList.add('flex');

        for(let i = 0; i < buttons.length; i++) {

            const $button = document.createElement('button');

            $button.innerText = buttons[i].name;
            $button.classList.add(
                'vs-component',
                'vs-button',
                'default',
                'ld-button',
                'button-header',
            );

            $button.style.overflow = 'inherit';

            if (buttons[i].icon !== null && buttons[i].icon !== undefined) {
                if (buttons[i].icon) {
                    $button.innerHTML = `<i class="vs-icon icon-scale vs-button--icon feather ${buttons[i].icon}"></i>`;
                }
            }

            if (buttons[i].styleClasses !== null && buttons[i].styleClasses !== undefined) {
                if (buttons[i].styleClasses) {
                    $button.classList.add(...buttons[i].styleClasses);
                }
            } else {
                $button.classList.add(
                    'mr-6',
                    'vs-button-dark',
                    'vs-button-border',
                    'ripple',
                    'smaller'
                );
            }

            if (buttons[i].hidden !== null && buttons[i].hidden !== undefined) {
                if (buttons[i].hidden) {
                    $button.classList.add('hidden');
                }
            }

            if (buttons[i].custom && typeof buttons[i].custom === 'function') {
                buttons[i].custom($button, params.data);
            }

            $button.onclick = buttons[i].onclick(params.data, $containerButtons);

            $containerButtons.appendChild($button);
        }

        return $containerButtons;
    }

    return render;

}
